import moment from 'moment';
import { routeConfigCommon, routeConfigAdmin,routeConfigVendor, routeConfigSubVendor} from 'routes/RouteConfig';
import { emailReg, mobileNumberReg } from './Regex';
import ErrorMessage from 'components/error/ErrorMessage';
  
  export const getCurrentUser = () => {
    let user = null;
    try {
      user =
        localStorage.getItem("token") != null
          ? localStorage.getItem("token")
          : null;
    } catch (error) {
      user = null;
    }
    return user;
  };
  
  export const setCurrentUser = (user) => {
    try {
      if (user) {
        return user.data
      } else {
        return user
      }
    } catch (error) {
      return error
    }
  };

  export const handleValidationForm = (data) => {
    let formIsValid = true;
    let errorVal = {};
    const emailRegex = emailReg;
    const mobileRegex = mobileNumberReg;
    let keys = Object.keys(data);
  
    keys.forEach((type, idx) => {
      // Prevent empty spaces at the beginning of the input
      if (typeof data[type] === 'string' && data[type].startsWith(' ')) {
        formIsValid = false;
        errorVal[type] = (
          <ErrorMessage errorMessage={'Cannot start with an empty space'} />
        );
        return;
      }
  
      switch (type) {
        case "mobileOrEmail":
          //check input validation
          if (type === "mobileOrEmail" && data[type]?.length !== 10) {
            if (emailRegex.test(data[type])) {
              errorVal[type] = "";
            } else {
              formIsValid = false;
              errorVal[type] = (
                <ErrorMessage errorMessage={'Email or Mobile is incorrect'} />
              );
            }
          }else if(data[type]?.length === 10){
            if(Number(data[type])){
              errorVal[type] = "";
            }else{
              formIsValid = false;
              errorVal[type] = (
                <ErrorMessage errorMessage={'Email or Mobile is incorrect'} />
              );
            }
          } else {
            errorVal[type] = "";
          }
          break;
        case "vendorName":
          //check input validation
          if (type === "vendorName" && data[type]?.length < 1) {
            formIsValid = false;
            errorVal[type] = (
              <ErrorMessage errorMessage={'This field is required'} />
            );
          } else {
            errorVal[type] = "";
          }
          break;
        case "number":
          //check input validation
          if(data[type]?.length !== 10){
            formIsValid = false;
            errorVal[type] = (
              <ErrorMessage errorMessage={'Mobile number is incorrect'} />
            );
          } 
          else if (!mobileRegex.test(data[type])) {
            // Check if it matches the mobile number regex
            formIsValid = false;
            errorVal[type] = (
              <ErrorMessage errorMessage={'Mobile number is incorrect'} />
            );
          } else {
            errorVal[type] = "";
          }
          break;
        case "mobile":
          //check input validation
          if(data[type]?.length !== 10){
            formIsValid = false;
            errorVal[type] = (
              <ErrorMessage errorMessage={'Mobile number is incorrect'} />
            );
          } else if (data[type]?.length === 10) {
            if (Number(data[type])) {
            } else {
              formIsValid = false;
              errorVal[type] = (
                <ErrorMessage errorMessage={'Mobile number is incorrect'} />
              );
            }
          } else {
            errorVal[type] = "";
          }
        break;
        case "email":
          //check input validation
          if (type === "email" && emailRegex.test(data[type])) {
            errorVal[type] = "";
          } else {
            if(data[type]?.length > 0){
              formIsValid = false;
              errorVal[type] = (
                <ErrorMessage errorMessage={'Enter a valid email address'} />
              );
            }
          }
          break;
        default:
          formIsValid = true;
          errorVal = {};
      }
  
      // Check if required is false and length is 0
      if (!data[type] && data[type]?.length === 0) {
        errorVal[type] = "";
      }
    });
  
    return { formIsValid, errorVal };
  };
  
  export const appRoot = "/app";

  export const isAuthUsers = (path) => {
    const isVendorPresent = window.location.origin.includes('vendor');
    const isSubVendorPresent = window.location.origin.includes('subvendor');
    let isAuth = false;
    const role =  localStorage.getItem('role') ? localStorage.getItem('role') : isVendorPresent ? 'vendorCompany' : isSubVendorPresent ? 'subVendorCompany' : 'adminCompany';
    let routeConfig = routeConfigCommon
    if(role === 'adminCompany'){
      routeConfig = routeConfigCommon.concat(routeConfigAdmin)
    }
    else if(role === 'vendorCompany'){
      routeConfig = routeConfigCommon.concat(routeConfigVendor)
    }
    else if( role ==='subVendorCompany'){
      routeConfig = routeConfigCommon.concat(routeConfigSubVendor)
    }
    routeConfig.forEach((route) => {
      if (route.path === path) {
        isAuth = route.isAuth;
      }
      return isAuth;
    });
    
    return isAuth
  }

  export const truncateComment = (comment, wordLimit) => {
    if (comment?.length > wordLimit) {
      return comment.slice(0, wordLimit) + "...";
    } else {
      return comment;
    }

  };

  export const dateFormate = (date, dFormate) => {
    switch (dFormate) {
      case "fromNowFormat":
      return moment(date).fromNow();
      default:
      return moment(date).format(dFormate)
  };
}

  export const getTimeFormat = (data) => {
    if (data) {
      return moment(data).format("HH:mm");
    }
  };
  export const abbreviateNumber = (value) => {
    if (value > 999 && value < 100000) {
      return Number(value / 1000).toFixed(2) + "K";
    }
  
    //Formatting to Lakhs
    else if (value >= 100000 && value <= 10000000) {
      return Number((value / 100000).toFixed(2)) + "L";
    }
  
    //Formatting to crores
    else if (value >= 10000000) {
      return Number((value / 10000000).toFixed(2)) + "cr";
    }
  
     else if (value < 900) {
      return Number(value).toFixed(2);
    }
  
    return value;
  };

  // Function to fix the digit after decimal
export const formatNumber = (value) => {
  if (typeof value === "number") {
    return value.toFixed(2);
  }
  return value;
};

//Currency formatter
export const formatCurrency = (amount) => {
  if (!isNaN(amount)) {
    const tempAmount = formatNumber(amount);
    return new Intl.NumberFormat("en-IN").format(tempAmount);
  }
  return amount || "0";
};

export const getReservationDetailsObject = (reservationData) => {
  if (reservationData?.AirportTrip) {
    return reservationData?.AirportTrip;
  } else if (reservationData?.B2bRentalTrip) {
    return reservationData?.B2bRentalTrip;
  } else if (reservationData?.OutStationTrip) {
    return reservationData?.OutStationTrip;
  } else if (reservationData?.OutStationTripOneWay) {
    return reservationData?.OutStationTripOneWay;
  } else {
    return {};
  }
};